import { useTranslate } from '@festina-life/ui/hooks'

import { useParameterContext } from '../../context/parameterContext'
import { partitionValueOperations } from '../../uiModels/parameterOperations/partitionValueOperations'
import { ParameterValueOperationsSection } from './ParameterValueOperationsSection'

/**
 * Shows a list of parameter value create and amend operations and controls for approving each individual operation.
 * In order to approve a parameter value operation the component allows to make all other operations hidden
 * so that reviewers can focus on the operation they are approving.
 */
export const ParameterValueOperations = () => {
  const translate = useTranslate()
  const { allParameterValueOperations } = useParameterContext()
  const { creates, amends } = partitionValueOperations(
    allParameterValueOperations,
  )

  return (
    <div className="flex flex-col size-full overflow-hidden">
      {!!creates.length && (
        <ParameterValueOperationsSection
          title={translate('parameterValues.sidebar.value.title')}
          tip={translate('parameterValues.sidebar.value.tip')}
          operations={creates}
        />
      )}
      {!!amends.length && (
        <ParameterValueOperationsSection
          title={translate('parameterValues.sidebar.amendment.title')}
          tip={translate('parameterValues.sidebar.amendment.tip')}
          operations={amends}
          className="shrink-0 max-h-1/2"
        />
      )}
    </div>
  )
}
